import Footer from "../constant-screens/footer";
import Header from "../constant-screens/header";
import Navbar from "../constant-screens/navbar";
import LegalGuidesScreenBody from "../half-screens/legalGuidesScreenBody";

function LegalGuides() {
 return(
  <div>
   <Header />
   <Navbar />
   <LegalGuidesScreenBody />
   <Footer />
  </div>
 );
}

export default LegalGuides;